import { axios } from "../../../packs/axios";

export const ReportAPI = {
  fetchImpactReportEventTypes() {
    return axios.get(`/api/v3/reports/options?report[type]=Reports::ImpactReport`)
      .then((resp) => resp.data.event_types);
  },
  postImpactReportJob(options) {
    return axios.post(`/api/v3/reports`, options)
      .then((resp) => resp.data.report.id);
  },
  fetchReport(reportId) {
    return axios.get(`/api/v3/reports/${reportId}`)
      .then((resp) => resp.data);
  }
};
